import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    label:
      'Please give us an idea of what you have been up to recently. Have there been any changes to your daily routines, or major life events that occurred recently? If so, what were they?',
    field: 'ciDietitianConsultation',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'dietitianConsultation',
      required: true,
      placeholder: 'Please describe'
    }
  },

  {
    label:
      'What was your biggest win recently? Did you recently start a new exercise routine, are you still meal planning, or perhaps have you started eating something that you never thought you would ever even try?',
    field: 'ciBiggestWin',
    type: 'info',
    required: true,
    answer: {
      type: 'text',
      name: 'biggestWin',
      required: true,
      placeholder: 'Please describe'
    }
  },

  {
    label: 'Do you usually skip Breakfast meal?',
    field: 'ciSkipBreakfast',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesSkipBreakfast',
          value: 'Yes'
        },
        {
          key: 'noSkipBreakfast',
          value: 'No',
          answer: {
            type: 'list',
            items: [
              {
                label:
                  'What meals do you usually eat for breakfast? Please be specific about the major ingredients (omelet would be egg whites, mushrooms and canola oil)',
                type: 'text',
                name: 'describeBreakfast',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        }
      ]
    }
  },

  {
    label: 'Do you usually skip Lunch meal?',
    field: 'ciSkipLunch',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesSkipLunch',
          value: 'Yes'
        },
        {
          key: 'noSkipLunch',
          value: 'No',
          answer: {
            type: 'list',
            items: [
              {
                label:
                  'What meals do you usually eat for lunch? Give details about the major ingredients (veggie sandwich would be 2 slices of whole wheat bread, mayo, cucumbers, tomatoes and alfalfa sprouts)',
                type: 'text',
                name: 'describeLunch',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        }
      ]
    }
  },

  {
    label: 'Do you usually skip Dinner meal?',
    field: 'ciSkipDinner',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesSkipDinner',
          value: 'Yes'
        },
        {
          key: 'noSkipDinner',
          value: 'No',
          answer: {
            type: 'list',
            items: [
              {
                label:
                  'What meals do you usually eat for dinner? Share the major ingredients in a typical dinner (salmon dinner would be salmon fillet, mashed potatoes, green beans and a glass of red wine)',
                type: 'text',
                name: 'describeDinner',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        }
      ]
    }
  },

  {
    label: 'Do you snack often?',
    field: 'cisnackOften',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yesSnack',
          value: 'Yes',
          answer: {
            type: 'list',
            items: [
              {
                label: 'What do you snack?',
                type: 'text',
                name: 'describeSnack',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        },
        { key: 'noSnack', value: 'No' }
      ]
    }
  },

  {
    //
    label:
      "What is your biggest challenge currently? Think specifically about the issue: if you're getting take out very often, is it because you have cravings, or because you enjoy take out?",
    field: 'ciBiggestChallenge',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'notDoingAnyCardio', value: 'Currently not doing any cardio' },
        {
          key: 'notDoingAnyResistanceTraining',
          value: 'Currently not doing any resistance training'
        },
        { key: 'cravings', value: 'Cravings' },
        { key: 'emtionalEating', value: 'Emotional eating' },
        { key: 'eatingOut', value: 'Eating out/getting take-out very often' },
        {
          key: 'eatingHighFat',
          value: 'Eating high-fat foods or high-sugar foods'
        },
        { key: 'largePortions', value: 'Large portions' },
        { key: 'grazing', value: 'Grazing (constantly snacking)' },
        { key: 'skippingMeals', value: 'Skipping meals' },
        { key: 'bongeEating', value: 'Binge eating' },
        { key: 'none', value: 'None', uncheckOthers: true }
      ]
    }
  }, //

  {
    //
    label: 'What are the biggest contributing factors for this challenge? ',
    field: 'ciBiggestFactor',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'lackOfTime', value: 'Lack of time' },
        { key: 'pain', value: 'Pain' },
        { key: 'fatigue', value: 'Fatigue' },
        { key: 'stress', value: 'Stress' },
        { key: 'lackOfCookingSkills', value: 'Lack of cooking skills' },
        { key: 'pickyEater', value: 'Picky eater' },
        { key: 'bigAppetite', value: 'Big appetite' },
        { key: 'lackOfAppetite', value: 'Lack of appetite' },
        {
          key: 'Other',
          value: 'Other (indicate)',
          answer: {
            type: 'list',
            required: true,
            items: [
              {
                type: 'text',
                name: 'other',
                required: true,
                placeholder: 'Please describe'
              }
            ]
          }
        }
      ]
    }
  }, //

  {
    //
    // Education Slide
    field: 'ciEducationSlide',
    type: 'info',
    educationalSlide:
      "Thanks for your answers - we'll review on our upcoming call.",
    label: '',
    answer: {}
  }
];
export default questionsModels;
